import { render, staticRenderFns } from "./date-pickers.vue?vue&type=template&id=4283bcea"
import script from "./date-pickers.vue?vue&type=script&lang=js"
export * from "./date-pickers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports